@defer (when siteSchedule()) {
  <article class="schedule">
    <header>
      <app-toolbar>
        <div class="right">
          <app-button size="medium" label="Upload" title="Upload schedule" icon="mdi mdi-upload" (click)="uploadSchedule()" [disabled]="true" [isDisabled]="true"></app-button> <span class="seperator">|</span>
          <app-button size="medium" label="Update from suggested" title="Get latest schedule" icon="mdi mdi-update" (click)="getSchedule()" [isCTA]="true"></app-button>
        </div>
      </app-toolbar>
    </header>
    <main>
      <table class="table">
        <thead>
          <tr>
            <th class="day">Day</th>
            <th class="text-center">On</th>
            <th class="text-center">Off</th>
            <th></th>
          </tr>
        </thead>
        <tbody class="fourd">
          @for (day of siteSchedule().days; track $index) {
            <tr>
              <td class="day">{{ day.day }}</td>
              <td class="text-center on">
                <input class="fourd" type="time" [(ngModel)]="day.timeOn" />
              </td>
              <td class="text-center off">
                <input class="fourd" type="time" [(ngModel)]="day.timeOff" />
              </td>
              <td>
                <i class="mdi mdi-close can-click" title="Clear" (click)="clearDay(day)"></i>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </main>
    <footer>
      <app-toolbar [hasBackground]="false">
        <div class="right">
          <app-button size="medium" label="Save" title="Save schedule" icon="mdi mdi-content-save" (click)="saveSchedule()" [isDisabled]="true"></app-button>
        </div>
      </app-toolbar>
    </footer>
  </article>
} @placeholder {
  <i class="mdi mdi-spin-x2 mdi-loading"></i>
}
